import React from 'react';

const shareActionBar = (props) => {

    return (
      <div className="share-action-bar">
        {props.children}
      </div>
    );

}

export default shareActionBar;
